import superagent from 'superagent'
import { getGroupPosition } from 'redux/navigation/selectors'
import { getServerUrl } from 'redux/configuration/selectors'
import { initializeGroup } from 'redux/visualizer/actions'
import { getMediaList } from 'redux/mediaList/selectors'
import { buildApiGroupQueryString } from 'redux/queryParams/selectors'
import { addError } from 'redux/notifications/actions'
import { addFetchingMedia } from 'redux/fetchingMedia/actions'

export const INIT_MEDIA_LIST = 'INIT_MEDIA_LIST'
export const initMediaList = mediaList => ({
    type: INIT_MEDIA_LIST,
    mediaList,
})

export function fetchMedia(start, end) {
    return async function fetchMedia(dispatch, getState) {
        dispatch(addFetchingMedia(start, end))
        const serverUrl = getServerUrl(getState())
        const group = getGroupPosition(getState())
        const queryParams = buildApiGroupQueryString(getState(), {
            start,
            end,
            group,
        })
        const url = `${serverUrl}/visualizer/api${queryParams}`
            await superagent
            .get(url)
            .then((res) => {
                const mergedMedia = { ...getMediaList(getState()), ...res.body }

                dispatch(initMediaList(mergedMedia))
            })
            .catch(function(err) {
                dispatch(addError('visualizer:error.label'))
            })
    }
}

export function fetchGroup(group) {
    return async function retrieveGroup(dispatch, getState) {

        const serverUrl = getServerUrl(getState())
        const queryParams = buildApiGroupQueryString(getState(), { group })
        const url = `${serverUrl}/visualizer/api${queryParams}`

        await superagent.get(url)
        .then((res) => {
            if (res.ok)
            {
                dispatch(initializeGroup(res.body))
            }
        })
        .catch(function(err) {
            dispatch(addError('visualizer:error.label'))
        })

    }
}
